module.exports = __webpack_public_path__ + "img/three1Red.6c416650.jpg";